module.exports = __webpack_public_path__ + "static/media/2.2f50a35d.jpg";